/**
 * App-wide copy constants.
 */
export const DEFAULT_APP_NAME = "V&V";

/**
 * Must match the backend's SEED_DEMO_USER_EMAIL / SEED_DEMO_USER_PASSWORD
 * seed defaults. Only shown in the UI when demo credentials are enabled via
 * config (VITE_SHOW_DEMO_CREDENTIALS / window.__RUNTIME_CONFIG__).
 */
export const DEMO_USER_EMAIL = "demo@example.com";
export const DEMO_USER_PASSWORD = "Demo1234!";

export const DEMO_CREDENTIALS_BANNER_TEXT = `Demo login — email: ${DEMO_USER_EMAIL}, password: ${DEMO_USER_PASSWORD}`;
